import styled from 'styled-components';
import { colors, styleHelpers } from '../../../theme/style-helpers';

export const Container = styled.div`
    display: grid;
    grid-gap: 32px;
`;

export const TextProperty = styled.div`
    font-size:1.4rem;
    margin: 32px 0;
    font-weight: 500;

    .title {
        margin-bottom: 10px;
    }
`;

export const EditButtonGroup = styled.div`
    width: 100%;

    ${styleHelpers.mobile`
        text-align: left;
        order: 1;
    `}
`;

export const LineButton = styled.button`
    -webkit-appearance: none;
    background: none;
    border: none;
    display: inline-flex;
    align-items: center;
    font-size: 1.6rem;
    line-height: 2rem;
    font-weight: 500;
    cursor: pointer;
    color: ${({ disabled }) => (disabled ? colors.COOL_GREY : colors.BLACK)};
    text-decoration: none;
    padding: 0px;
`;

export const SuccessMsg = styled.div`
    font-size: 1.6rem;
    line-height: 2rem;
    font-weight: 500;
    color: ${colors.LAND_GREEN};
    text-decoration: none;
    padding: 0px;
`;

export const Icon = styled.img`
    margin-right: 10px;

    &.right {
        margin-right: 0;
        margin-left: 10px;
    }
`;
